export default "__VITE_ASSET__BVj2soVI__"